export const CONTEST_ADAPTER_CAMPAIGN_ID_KEY = 'campaignId';
export const CONTEST_ADAPTER_ROUND_KEY = 'round';

export interface ContestAdapterFields {
  campaignId: string;
  round: string;
}

const readTrimmedString = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

export const parseContestAdapterFields = (
  adapterConfig: Record<string, unknown> | null | undefined,
): ContestAdapterFields => ({
  campaignId: readTrimmedString(adapterConfig?.[CONTEST_ADAPTER_CAMPAIGN_ID_KEY]),
  round: readTrimmedString(adapterConfig?.[CONTEST_ADAPTER_ROUND_KEY]),
});

export const buildContestAdapterConfig = (
  fields: ContestAdapterFields,
): Record<string, unknown> => ({
  [CONTEST_ADAPTER_CAMPAIGN_ID_KEY]: fields.campaignId.trim(),
  [CONTEST_ADAPTER_ROUND_KEY]: fields.round.trim(),
});
